import React, { Component } from 'react'
import GenericEvent from './GenericEvent'

export default class PageViewEvent extends Component {
  render() {
    return (
      <GenericEvent {...this.props} eventLabel="viewed"/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/PageViewEvent.js